import { milisecondsInSecond, secondsInMinute, minutesInHour } from './constants';

/**
 * @typedef {Object} Duration
 * @property {number} seconds - number of seconds
 * @property {number} minutes - number of minutes
 * @property {number} hours - number of hours
 */
/**
 * Returns an object representing the duration in seconds, minutes and hours.
 *
 * @param {number} numberOfMilliseconds - number of milliseconds
 * @returns {Duration} -
 */
export const buildTimeDuration = (numberOfMilliseconds: number): Duration => {
  const numberOfSeconds = Math.floor(numberOfMilliseconds / milisecondsInSecond);
  const numberOfMinutes = Math.floor(numberOfSeconds / secondsInMinute);
  const numberOfHours = Math.floor(numberOfMinutes / minutesInHour);
  const seconds = numberOfSeconds - numberOfMinutes * secondsInMinute;
  const minutes = numberOfMinutes - numberOfHours * minutesInHour;

  return { seconds, minutes, hours: numberOfHours };
};
